import { formatTime } from '../../filter'

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this

	const applyCancels = order.applyCancels
	if (!applyCancels || !applyCancels.length) {
		return false
	}
	let arr = []
	const obj = {
		title: '撤单原因',
		children: arr,
	}

	if (applyCancels) {
		const operatorCancel = applyCancels.find(
			item => item.dataType === 'application'
		)

		if (operatorCancel.type === '2') {
			arr = [
				{
					label: '撤单发起时间',
					value: formatTime(operatorCancel.createTime),
				},
				{
					label: '撤单状态',
					value: setting.cancelTypeMap[operatorCancel.type],
				},
				{
					label: '现场位置',
					value: operatorCancel.address,
				},
				{
					label: '申请原因',
					value: operatorCancel.reason,
				},
			]
			obj.images = operatorCancel.mediaInfoList
		} else {
			arr = [
				{
					label: '撤单发起时间',
					value: formatTime(operatorCancel.createTime),
				},
				{
					label: '撤单状态',
					value: setting.cancelTypeMap[operatorCancel.type],
				},
				{
					label: '申请原因',
					value: operatorCancel.reason,
				},
			]
		}
	}

	obj.children = arr
	obj.span = {
		现场位置: 12,
		申请原因: 12,
	}

	return obj
}
